import * as ko from "knockout";
import {TType} from "./index";
import {IKnockoutComponent, IMessageData} from "../../../index";
import itemHtml from './item.html?raw';

export const template = itemHtml;

export class ItemViewModel {
    component!: IKnockoutComponent
    readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    readonly prefix: KnockoutObservable<string | null> = ko.observable(null)
    readonly title: KnockoutObservable<string | null> = ko.observable(null)
    readonly type: TType = 'item'
}
